export default function validateLength(length) {
  return function(value) {
    return value && value.length ? value.length >= length : false;
  }
}



// WEBPACK FOOTER //
// ./src/lib/validateLength.js